import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
/**
 * Draw-proposal confirmation (for the initiating player). Once sent, the turn
 * timer is paused until the other player responds (see ArenaBattle::proposeDraw).
 */
export default class ProposeDrawConfirmModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", false);
  }
  className() {
    return 'ArenaProposeDrawModal Modal--small';
  }
  title() {
    return m('[', null, m("i", {
      className: "fas fa-handshake"
    }), " ", app.translator.trans('forumaker-arena.forum.propose_draw.title'));
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "ArenaProposeDrawModal-text"
    }, app.translator.trans('forumaker-arena.forum.propose_draw.confirm_text')), m("div", {
      className: "ArenaProposeDrawModal-actions"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      icon: "fas fa-handshake",
      loading: this.loading,
      onclick: () => this.propose()
    }, app.translator.trans('forumaker-arena.forum.propose_draw.confirm_btn')), m(Button, {
      className: "Button Button--block",
      disabled: this.loading,
      onclick: () => this.hide()
    }, app.translator.trans('forumaker-arena.forum.propose_draw.cancel_btn'))));
  }
  async propose() {
    this.loading = true;
    m.redraw();
    try {
      var _this$attrs$onPropose, _this$attrs;
      await app.request({
        method: 'POST',
        url: "".concat(app.forum.attribute('apiUrl'), "/arena/battles/").concat(this.attrs.battle.id(), "/propose-draw")
      });
      this.hide();
      (_this$attrs$onPropose = (_this$attrs = this.attrs).onProposed) == null || _this$attrs$onPropose.call(_this$attrs);
    } catch (_unused) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('forumaker-arena.forum.propose_draw.error'));
      this.loading = false;
      m.redraw();
    }
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ProposeDrawConfirmModal', ProposeDrawConfirmModal);